export const CMS_IMPRESSION_VIEWS = [
  { id: 'cms_impressions_by_site', title: 'CMS impressions by site', fields: ['site', 'impressions'] },
  { id: 'cms_impressions_by_campaign', title: 'CMS impressions by campaign', fields: ['campaign', 'impressions'] },
  { id: 'cms_impressions_by_media', title: 'CMS impressions by media', fields: ['campaign', 'media', 'impressions'] }
].map(view => ({ ...view, display: 'table', config: { height: 300, columnOrder: view.fields },
  plotOptions: { columns: view.fields.map(field => field[0].toUpperCase() + field.slice(1)) } }));

